import { hasRenderableTransferMatchSources } from "@components/transactions/views/TransferMatchCell";
import type { TransferMatchSources } from "@components/transactions/views/TransferMatchCell";
import {
    IntercompanyMatchContext,
    IntercompanyTransactionRow,
} from "./intercompanyTransactions.lib";

export type IntercompanyMatchPresentation =
    | { kind: "in_transit"; counterpartName: string }
    | { kind: "transfer_match" }
    | { kind: "computed_match" }
    | { kind: "add_transaction_match" }
    | { kind: "add_journal_entry" };

export function hasRenderableTransferMatch(
    transaction: TransferMatchSources | undefined,
): boolean {
    return hasRenderableTransferMatchSources(transaction);
}

export function getIntercompanyMatchPresentation(
    row: IntercompanyTransactionRow,
): IntercompanyMatchPresentation {
    if (row.isInformational) {
        return {
            kind: "in_transit",
            counterpartName: row.otherEntityName,
        };
    }
    if (
        row.status === "Matched" &&
        hasRenderableTransferMatch(row.transaction)
    ) {
        return { kind: "transfer_match" };
    }
    if (row.status === "Matched") {
        return { kind: "computed_match" };
    }
    if (row.sourceAction === "find_transaction_match") {
        return { kind: "add_transaction_match" };
    }
    return { kind: "add_journal_entry" };
}

export function getComputedMatchContext(
    row: IntercompanyTransactionRow,
): IntercompanyMatchContext {
    if (row.matchContext) {
        return row.matchContext;
    }
    return {
        entityId: row.otherEntityId,
        entityName: row.otherEntityName,
        accountLabel: row.otherEntityName,
        reference: "",
        date: row.date,
        amount: -row.amount,
        journalEntryCount: 0,
    };
}
